// 平台清單：以圖示呈現，hover、鍵盤聚焦或點一下（觸控）顯示完整平台名稱。
// 名稱同時放在視覺隱藏的文字裡，螢幕閱讀器與搜尋都讀得到。
import type { PlatformKey } from '@dayone/core/dictionaries';
import { memo } from 'react';
import { t } from '../i18n/zh-TW.ts';
import { Hint } from './Hint.tsx';
import { PlatformIcon, uniqueGlyphs } from './icons/PlatformIcon.tsx';

export const platformNames = (platforms: readonly PlatformKey[]) => platforms.map((p) => t.platforms[p] ?? p);

export const PlatformList = memo(function PlatformList({ platforms }: { platforms: readonly PlatformKey[] }) {
  if (platforms.length === 0) return null;
  const names = platformNames(platforms).join('、');
  return (
    <Hint content={t.card.platformsHint(names)}>
      <button type="button" className="platforms">
        {uniqueGlyphs(platforms).map((p) => (
          <PlatformIcon key={p} platform={p} />
        ))}
        <span className="sr-only">
          {t.filters.platforms}：{names}
        </span>
      </button>
    </Hint>
  );
});

/** 圖示＋名稱的標籤（詳情頁、篩選等空間足夠的地方） */
export function PlatformTag({ platform }: { platform: PlatformKey }) {
  return (
    <span className="platform-tag">
      <PlatformIcon platform={platform} />
      {t.platforms[platform] ?? platform}
    </span>
  );
}
